import { Box, Typography } from "@mui/material"
import { Info } from "@mui/icons-material"
import { useMemo } from "react"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { servicoInformationModalIsOpenedStore$ } from "src/store/vendas/projetos/store"
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store"

export const ResumoProjeto = () => {
  const { resultado_calculos, valor_servico_pis_cofins } = useProjetosHibridoStore(store => store.state.data)

  const resumoFields = useMemo(()=>{
    return [
      {
        label: "Potência do gerador (kWp)",
        value: Number(resultado_calculos?.componentes?.potencia_gerador || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      },
      {
        label: "Valor dos produtos",
        value: Formater.toString(resultado_calculos?.componentes?.valor || 0, TypeRecords.CURRENCY),
      },
      {
        label: "Valor do serviço da revenda com PIS/COFINS",
        value: Formater.toString(valor_servico_pis_cofins || 0, TypeRecords.CURRENCY),
        prefixIcon: (
          <Info style={{ cursor: 'pointer' }} onClick={() => servicoInformationModalIsOpenedStore$.next(true)} color="primary" />
        ),
        hide: !valor_servico_pis_cofins || valor_servico_pis_cofins === 0
      },
      {
        label: 'Valor total',
        value: Formater.toString((resultado_calculos?.servicos?.valor_com_pis_cofins || 0) + (resultado_calculos?.componentes?.valor || 0), TypeRecords.CURRENCY)
      }
    ]
  },[resultado_calculos?.componentes?.potencia_gerador, resultado_calculos?.componentes?.valor, resultado_calculos?.servicos?.valor_com_pis_cofins, valor_servico_pis_cofins])

  return (
    <Box className="row X12" style={{ padding: '0 0 16px 16px', marginBottom: 10, marginTop: 50 }}>
      <Box className="X5">
        <Box mb={2}>
          <Typography color='primary' align='left' variant='h6'><strong>Resumo do projeto:</strong></Typography>
        </Box>

        {resumoFields.filter(item => !item.hide).map(item => (
          <Box display='flex' width='100%'>
            <Box display='flex' width='70%' alignItems={'flex-start'} flexDirection={"column"}>
              <Typography style={{ textAlign: "start" }} variant='subtitle1'>{item.label}</Typography>
            </Box>
            <Box display='flex' justifyContent={"flex-end"} alignItems={'flex-start'} width='30%' flexDirection={"row"}>
              {item.prefixIcon}
              <Typography style={{ marginLeft: 10, textAlign: "end" }} variant='subtitle1'>{item.value}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}